import { render, staticRenderFns } from "./ConferenceCard.vue?vue&type=template&id=64b3b77a&scoped=true&"
import script from "./ConferenceCard.vue?vue&type=script&lang=js&"
export * from "./ConferenceCard.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceCard.vue?vue&type=style&index=0&id=64b3b77a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3b77a",
  null
  
)

export default component.exports